import { z } from "zod";

export const tipoSitioEnum = ["wireless_tower", "fiber_olt", "nodo", "otro"] as const;
export type TipoSitio = (typeof tipoSitioEnum)[number];

export const TIPO_SITIO_LABEL: Record<TipoSitio, string> = {
  wireless_tower: "Torre WiFi",
  fiber_olt: "OLT fibra",
  nodo: "Nodo",
  otro: "Otro",
};

export const sitioCreateSchema = z.object({
  nombre: z.string().min(1, "Requerido").max(100),
  tipo: z.enum(tipoSitioEnum),
  direccion: z.string().max(300).optional().or(z.literal("")),
  municipio: z.string().max(100).optional().or(z.literal("")),
  estado: z.string().max(100).optional().or(z.literal("")),
  latitud: z.union([z.coerce.number().min(-90).max(90), z.literal("")]).optional(),
  longitud: z.union([z.coerce.number().min(-180).max(180), z.literal("")]).optional(),
  altura_metros: z.union([z.coerce.number().int().min(0).max(500), z.literal("")]).optional(),
  notas: z.string().optional().or(z.literal("")),
  tags: z.array(z.string()).default([]),
});

export const sitioUpdateSchema = sitioCreateSchema.partial().extend({
  activo: z.boolean().optional(),
});

export type SitioCreateInput = z.infer<typeof sitioCreateSchema>;
export type SitioUpdateInput = z.infer<typeof sitioUpdateSchema>;

export type Sitio = {
  id: string;
  nombre: string;
  tipo: TipoSitio;
  direccion: string | null;
  municipio: string | null;
  estado: string | null;
  latitud: string | null;
  longitud: string | null;
  altura_metros: number | null;
  notas: string | null;
  tags: string[];
  activo: boolean;
  created_at: string;
  updated_at: string;
};

export type PagedSitios = {
  items: Sitio[];
  total: number;
  page: number;
  size: number;
  pages: number;
};
